import { retrieve, create } from "framework/http/endpoint";
import { createEntityRequest } from "framework/http/rest/jsonRequest";
import { UrlPathOfApiLocation } from "common/paths";
var ApiUriPrefix = "".concat(UrlPathOfApiLocation, "/api/1/");
var CompetitionIndexesApiUri = ApiUriPrefix + "competitions/index";
function apiGetCompAges() {
    var uri = "".concat(CompetitionIndexesApiUri, "/age");
    return retrieve(uri, null);
}
function apiGetCompDisciplines() {
    var uri = "".concat(CompetitionIndexesApiUri, "/discipline");
    return retrieve(uri, null);
}
function apiGetCompDefaultDances(compDances) {
    var uri = "".concat(CompetitionIndexesApiUri, "/defaultDances");
    var request = createEntityRequest(compDances);
    return create(uri, request);
}
function apiGetCompTypes() {
    var uri = "".concat(CompetitionIndexesApiUri, "/type");
    return retrieve(uri, null);
}
function apiGetCompCompetitors() {
    var uri = "".concat(CompetitionIndexesApiUri, "/competitor");
    return retrieve(uri, null);
}
function apiGetCompClasses() {
    var uri = "".concat(CompetitionIndexesApiUri, "/class");
    return retrieve(uri, null);
}
function apiGetCompSeries() {
    var uri = "".concat(CompetitionIndexesApiUri, "/series");
    return retrieve(uri, null);
}
export { apiGetCompAges, apiGetCompDisciplines, apiGetCompDefaultDances, apiGetCompTypes, apiGetCompCompetitors, apiGetCompClasses, apiGetCompSeries, };
